<template>
    <div class="layout-topbar">
      <template v-if="!$methods.isEmpty(user)">
        <Button @click="doLogout()"
                icon="pi pi-sign-out" class="topbar-tab-items login-button"/>
        <Button @click="goToProfileManagent()" icon="fa fa-user-circle" class="topbar-tab-items login-button"
                :label="$t('appTopBar.welcome') + (user.firstName != null ? ', ' + user.firstName : '')" icon-pos="right"/>
      </template>

      <Button @click="goToEsmo()"
              class="topbar-tab-items active" :label="$t('appTopBar.esmo')" style="float: left"/>
      <Button @click="goToMeetingCalendar()" icon="fa fa-calendar" class="topbar-tab-items"
              :label="$t('appTopBar.MeetingCalendar')" icon-pos="right" style="float: left"/>
      <Button @click="goToOncologyPro()"
              class="topbar-tab-items" :label="$t('appTopBar.OncologyPRO')" style="float: left"/>
  </div>
  <div class="layout-sub-topbar">
    <div class="layout-sub-topbar-container" :style="dynamicStyleContainerImage()">
      <button class="layout-topbar-logo p-link" style="margin-top:21px">
        <img id="layout-topbar-logo" alt="logo" src="/images/logo_esmo_org.svg" height="47"/>
      </button>
    </div>
  </div>
</template>

<script>
import {useUserStore} from "@/store/userStore";
import {VueScreenSizeMixin} from "vue-screen-size";
import {useAccreditationStore} from "@/store/accreditationStore";
import {useEndpointStore} from "@/store/endpointStore";
import {useLoadingStore} from "@/store/loadingStore";
import {useApplicationStore} from "@/store/applicationStore";
import {useDAMStore} from "@/store/DAMStore";

export default {
  mixins: [VueScreenSizeMixin],
  beforeCreate() {
    this.accreditationStore = useAccreditationStore()
    this.applicationStore = useApplicationStore()
    this.DAMStore = useDAMStore()
    this.endpointStore = useEndpointStore()
    this.loadingStore = useLoadingStore()
    this.userStore = useUserStore()
  },
  data() {
    return {}
  },
  computed: {
    darkTheme() {
      return this.$appState.darkTheme
    },
    user() {
      return this.userStore.user
    }
  },
  methods: {
    dynamicStyleContainerImage(){
      const fullScreen = 350
      return this.$vssWidth > 900 ? ('padding-left: ' + fullScreen + 'px') : 'padding-left: 1em '
    },
    goToProfileManagent(){
      this.$router.push('/profile-management')
    },
    goToEsmo(){
      location.href = "https://www.esmo.org"
    },
    goToMeetingCalendar(){
      location.href = "https://www.esmo.org/meeting-calendar"
    },
    goToOncologyPro(){
      location.href = "https://oncologypro.esmo.org"
    },
    doLogin() {
      this.$router.push('/accreditations')
    },
    doLogout() {
      this.accreditationStore.logout()
      this.applicationStore.logout()
      this.DAMStore.logout()
      this.endpointStore.logout()
      this.loadingStore.logout()
      this.userStore.logout()
      location.href = "https://www.esmo.org/newsroom/press-and-media-hub/meetings-calendar-for-press"
    },
    onMenuToggle(event) {
      this.$emit('menu-toggle', event);
    },
    onTopbarMenuToggle(event) {
      this.$emit('topbar-menu-toggle', event);
    },
    topbarImage() {
      return 'images/logo_esmo_org.svg';
    }
  },
}
</script>